import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import PublicNav, { PublicFooter } from './PublicNav';

export type LegalSection = { id: string; title: string; content: ReactNode };
export default function LegalLayout({title,description,kind,summary,sections}:{title:string;description:string;kind:'terms'|'privacy';summary:ReactNode;sections:LegalSection[]}) {
  return (
    <div className="policy-page">
      <PublicNav />
      <main id="policy-main">
        <div className="policy-hero">
          <div className="policy-container">
            <div className="policy-breadcrumb"><Link to="/">ReachAtlas</Link><span>/</span><span>Legal & privacy</span></div>
            <span className="eyebrow">CLEAR INFORMATION. INFORMED CHOICES.</span>
            <h1>{title}</h1>
            <p className="policy-description">{description}</p>
            <div className="policy-meta"><span>Last updated <time dateTime="2026-10-29">October 29, 2026</time></span><span>Applies to reachatlasleads.com</span></div>
            <nav className="policy-tabs" aria-label="Legal documents"><Link to="/terms" aria-current={kind==='terms'?'page':undefined}>Terms of service</Link><Link to="/privacy" aria-current={kind==='privacy'?'page':undefined}>Privacy policy</Link><Link to="/opt-out">Privacy choices ↗</Link></nav>
          </div>
        </div>
        <div className="policy-container policy-grid">
          <aside className="policy-sidebar">
            <nav aria-label={`${title} contents`}><span className="eyebrow">ON THIS PAGE</span><ol>{sections.map((s,i)=><li key={s.id}><a href={`#${s.id}`}><span>{String(i+1).padStart(2,'0')}</span>{s.title}</a></li>)}</ol></nav>
            <div className="policy-sidebar-contact"><strong>A question about this page?</strong><p>We’re here to help.</p><a href="mailto:support@reachatlasleads.com">Contact ReachAtlas ↗</a></div>
            <button className="policy-print" onClick={()=>window.print()}>Print or save as PDF ↓</button>
          </aside>
          <article className="policy-document" aria-label={title}>
            <div className="policy-summary"><span className="eyebrow">AT A GLANCE</span>{summary}<p className="policy-summary-note">This overview is a guide. The sections below provide the details.</p></div>
            {sections.map((section,i)=><section className="policy-section" id={section.id} key={section.id}><div className="policy-section-heading"><span>{String(i+1).padStart(2,'0')}</span><h2>{section.title}</h2></div>{section.content}</section>)}
            <div className="policy-contact-card"><span className="eyebrow">LET’S KEEP THINGS CLEAR</span><h2>Need a hand?</h2><p>For account, billing, or privacy questions, email <a href="mailto:support@reachatlasleads.com">support@reachatlasleads.com</a>.</p><Link to={kind==='terms'?'/privacy':'/terms'}>Read our {kind==='terms'?'privacy policy':'terms of service'} →</Link></div>
          </article>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
